import React, { useState, useEffect } from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    CircularProgress,
    Typography,
    Alert,
    AlertTitle
} from "@mui/material";
import outWardService from "../../../../services/outWardService";
import invoiceIntegratorService from '../../../../services/invoiceIntegrator';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInvoice } from '../../../../redux/actions/InvoicesActions';

export const InvoiceSend = ({ openDialog, handleCloseDialog, data }) => {
    const [loading, setLoading] = useState(false);
    const [invoiceIntegratorSettingRds, setInvoiceIntegratorSettingRds] = useState(null);
    const [status, setStatus] = useState({
    });
    const dispatch = useDispatch();
    const authUserId = useSelector(state => state?.auth?.user?.id);
    const getSettings = async () => {
        var response = await invoiceIntegratorService.getInvoiceIntegratorAccountsApi(authUserId);
        setInvoiceIntegratorSettingRds(response?.data?.data?.data);
    };
    const create = async () => {
        setLoading(true);
        setStatus(null);
        if (loading) {
            return;
        }
        try {
            const request = {
                invoiceRD: data,
                invoiceIntegratorSettingRds: invoiceIntegratorSettingRds
            }
            const response = await outWardService.transferInvoice(request);
            if (response.statusCode == 500) {
                setStatus({
                    success: false,
                    message: response.Message || response.title
                });
            } else {
                setStatus({
                    success: response.state==1 ?true:false,
                    message:response.state==1 ?"İşlem başarılı Fatura durumu alanında takip edebilirsiniz":"Hata oluştu" + " " +response.message
                });
            }
          
               await dispatch(fetchInvoice(authUserId, 1, 10));
            

        } catch (error) {
            setStatus({
                success: false,
                message: error.response?.data?.Message || 'Fatura aktarma işlemi başarısız oldu'
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getSettings();
        if (!openDialog) {
            setLoading(false);
        }
        setStatus(null);
    }, [openDialog]);
    useEffect(() => {
        if (openDialog) {
            create();
        }
    }, [invoiceIntegratorSettingRds]);
    return (
        <Box>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle
                    sx={{
                        color: 'black',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: 2,
                        marginBottom: 3,
                    }}
                >
                    Fatura Aktarma Durumu
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 200
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <CircularProgress sx={{ mb: 2 }} />
                            <Typography variant="body1">
                                Fatura aktarılıyor, lütfen bekleyin...
                            </Typography>
                        </Box>
                    ) : status ? (
                        <Alert
                            severity={status.success ? "success" : "error"}
                            sx={{ width: '100%' }}
                        >
                            <AlertTitle>
                                {status.success ? "Başarılı" : "Hata"}
                            </AlertTitle>
                            {status.message}
                        </Alert>
                    ) : null}
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default InvoiceSend;